const Tasks = { scheduled_monitoring: "scheduled_monitoring" };
export { Tasks };
